import { render, staticRenderFns } from "./fastlogin.vue?vue&type=template&id=ebf73b68&scoped=true"
import script from "./fastlogin.vue?vue&type=script&lang=js"
export * from "./fastlogin.vue?vue&type=script&lang=js"
import style0 from "./fastlogin.vue?vue&type=style&index=0&id=ebf73b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf73b68",
  null
  
)

export default component.exports